import { Link } from 'react-router-dom';
import { useTranslation } from '../../../i18n/useTranslation';
import { routes } from '../../../Utils/routes';
import './Footer.css';

export function Footer() {
  const { tr } = useTranslation();
  return (
    <footer className="site-footer">
      <nav className="site-footer-nav">
        <Link to={routes.terms}>{tr('navTerms')}</Link>
        <Link to={routes.privacy}>{tr('navPrivacy')}</Link>
        <Link to={routes.refunds}>{tr('navRefunds')}</Link>
      </nav>
      {/* A year beside Hebrew needs isolating, or the digits and the name of
          the product swap places in an RTL paragraph. */}
      <p className="site-footer-note">
        <bdi>{tr('appName')}</bdi> · <bdi>{new Date().getFullYear()}</bdi>
      </p>
    </footer>
  );
}
